import styled from 'styled-components';
import { APPS_PHONE_MEDIA } from '../apps.constants';

export const Hero = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 240px;
  margin: 0 auto ${({ theme }) => theme.spacing.level5};
  border-radius: ${({ theme }) => theme.borderRadius.large};
`;

export const Facts = styled.dl`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: ${({ theme }) => `${theme.spacing.level4} ${theme.spacing.level5}`};
  margin: 0;
  ${({ theme }) => theme.font.bodyMedium};
  color: ${({ theme }) => theme.colors.onSurface};

  ${APPS_PHONE_MEDIA} {
    grid-template-columns: minmax(0, 1fr);
    row-gap: ${({ theme }) => theme.spacing.level2};
  }
`;

export const Term = styled.dt`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const FactValue = styled.dd`
  margin: 0;
  min-width: 0;

  ${APPS_PHONE_MEDIA} {
    margin-bottom: ${({ theme }) => theme.spacing.level4};
  }
`;

export const Steps = styled.ol`
  margin: 0;
  padding-left: ${({ theme }) => theme.spacing.level5};
`;

export const Instructions = styled.div`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 240px;
  overflow-y: auto;
`;
